const labels = {
  1: 'Food',
  2: 'Vehicles',
  3: 'Health Products',
  4: 'Consumer Products',
}

const CategoryList = ({ categories }) =>
  categories
    .map(cat => {
      return labels[cat]
    })
    .join(', ')

export default CategoryList
